import {
  getFirstLinkedItemOrDefault,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
import {
  getMappedLinkedItems,
  getCtaHrefValue,
  getFirstMappedLinkedItemOrDefault,
} from './utils';

export const accreditation_form = (
  data: PLAYER_PORTALS_MODELS.AccreditationForm,
) => {
  if (!data || !data?.elements) {
    return undefined;
  }

  const { elements } = data;

  return {
    title: elements?.title?.value,
    addNewRecordCTALabel: elements?.add_new_record_cta_label?.value,
    columns: getMappedLinkedItems(elements?.columns),
    callbackUrl: getCtaHrefValue(
      getFirstLinkedItemOrDefault(elements?.callback_url),
    ),
    accreditationContactForm: getFirstMappedLinkedItemOrDefault(
      elements.accreditation_contact_form,
    ),
    maxNumberOfApplicationsPerRole: getMappedLinkedItems(
      elements?.maximum_number_of_applications_per_role,
    ),
    maxNumberOfNominatedForDinner:
      elements?.maximum_number_of_nominated_for_dinner?.value,
    accreditationFormKontentItemCodename: data?.system?.codename,
  };
};

export default accreditation_form;
